import React, { useEffect, useState } from "react";
import { Formik, Form, Field, input, ErrorMessage } from "formik";
import * as Yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import { Row, Col, Modal } from "antd";
import { API_CREATE_MAIN_LAUNDRY } from "api/main-laundry-management";
import { CONSTANTS } from "config/constant";
import axios, { Axios } from "axios";
import TextareaField from "components/AddressAutocomplete/TextareaField";
import AddressAutocomplete from "components/AddressAutocomplete/AddressAutocomplete";
import { API_UPDATE_MAIN_LAUNDRY } from "api/main-laundry-management";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import { MdOutlineArrowBack } from "react-icons/md";
import { FaEye, FaEyeSlash } from "react-icons/fa"; // Import eye icons
import { API_GET_MAIN_LAUNDRY } from "api/main-laundry-management";

const EditLaundry = () => {
  const [autocompleteSuggestions, setAutocompleteSuggestions] = useState([]);
  const [confirmModalVisible, setConfirmModalVisible] = useState(false); // State for modal visibility
  const [valuesData, setValuesData] = useState(); // State for modal visibility
  const { t } = useTranslation();
  const location = useLocation();
  const Navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(true);
  const [data, setData] = useState();
  const [loading, setLoading] = useState();
  let { id } = useParams();
  // const data = location.state && location.state.data;

  const fetchData = async () => {
    setLoading(true);
    try {
      const newData = await API_GET_MAIN_LAUNDRY(id);
      console.log("provider", newData);
      setData(newData?.laundry);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  const searchAddress = async (address) => {
    // formik.setFieldValue("street_address_camp", address);
    console.log("address", address);
    try {
      // const response = await axios.get(
      //   `https://maps.googleapis.com/maps/api/place/autocomplete/json?input=${address}&key=${CONSTANTS?.googleApikey}`
      // );
      const response = await axios.get(`${CONSTANTS.BACKEND_URL_PUBLIC}/google/places-autocomplete?query=${address}`);
      if (
        response.data.status === "OK" &&
        response.data.predictions.length > 0
      ) {
        const predictions = response.data.predictions;
        setAutocompleteSuggestions(predictions);

        console.log("Address predictions:", predictions);
      } else {
        setAutocompleteSuggestions([]);
        // Handle no results or error cases
        console.error("No address predictions found or error occurred");
      }
    } catch (error) {
      // Handle request error
      console.error("Error fetching data from Google Places API", error);
    }
  };

  const onSelectAddress = async (selectedAddress, setFieldValue) => {
    console.log("selectedAddress", selectedAddress);
    try {
      // Fetch place details using  the Place Details request
      // const response = await axios.get(
      //   `https://maps.googleapis.com/maps/api/place/details/json?place_id=${selectedAddress.place_id}&key=${CONSTANTS?.googleApikey}`
      // );
      const response = await axios.get(`${CONSTANTS.BACKEND_URL_PUBLIC}/google/place-details?place_id=${selectedAddress.place_id}`);

      if (response.data.status === "OK") {
        const placeDetails = response.data.result;
        console.log("Place Details:", placeDetails);
        const postalCode = placeDetails?.address_components?.find((component) =>
          component.types.includes("postal_code")
        )?.long_name;
        const city = placeDetails?.address_components?.find((component) =>
          component.types.includes("locality")
        )?.long_name;
        const state = placeDetails?.address_components?.find((component) =>
          component.types.includes("administrative_area_level_1")
        )?.long_name;
        const country = placeDetails?.address_components?.find((component) =>
          component.types.includes("country")
        )?.long_name;
        const lat = placeDetails?.geometry?.location?.lat;
        const lng = placeDetails?.geometry?.location?.lng;
        console.log("postalCode", postalCode);
        setFieldValue("location", selectedAddress?.description);
        setFieldValue('geo',{coordinates:[lat,lng]})
        setFieldValue("location_lat", lat);
        setFieldValue("location_lng", lng);

        console.log("lat long", lat, lng);
        setAutocompleteSuggestions([]);
      } else {
        console.error("Error fetching place details from Google Places API");
      }
      setAutocompleteSuggestions([]);
    } catch (error) {
      console.error(
        "Error fetching place details from Google Places API",
        error
      );
    }
  };
  useEffect(() => {
    fetchData();
  }, [id]);
  
  return (
    <>
      <div className=" mb-16 flex h-full w-full items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-center">
        <div className="mt-[2vh] w-full max-w-full flex-col items-center md:pl-4 lg:pl-0">
          <Formik
            enableReinitialize
            initialValues={{
              laundry_name: data?.laundry_name,
              description: data?.description,
              phone_no: data?.phone_no,
              location: data?.location?.address,
              location_lat: data?.location_lat,
              location_lng: data?.location_lng,
              password: data?.password,
              email: data?.email,
              address: data?.address,
              geo:data?.geo,
            }}
            validationSchema={Yup.object({
              laundry_name: Yup.string()
                .required("Required")
                .matches(/^[^\d]+$/, "Name cannot contain numbers")
                .max(20, "Maximum character should be 20"),
              description: Yup.string()
                .required("Required")
                .test(
                  "max-words",
                  "Description must be at most 150 words",
                  (value) => value.trim().split(/\s+/).length <= 150
                ),
              email: Yup.string()
                .email("Invalid email format")
                .matches(
                  /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                  "Invalid email format"
                )
                .test("valid-domain", "Invalid email format", function (value) {
                  if (!value) return true; // Skip if empty
                  const domain = value.split("@")[1]; // Extract domain part
                  return !!domain && /\./.test(domain); // Check for dot in domain part
                })
                .max(40, "Maximum character long before @")
                .required("Required"),
              password: Yup.string().required("Required"),
              location: Yup.string().required("Required"),
              phone_no: Yup.string()
                .required("Required")
                .matches(/^[0-9]+$/, "Phone number must contain only numbers")
                .length(15, "please enter correct Phone number"),

            })}
            onSubmit={async (values, { setSubmitting, setFieldError }) => {
              console.log("values", values);
              setValuesData(values);
              setConfirmModalVisible(true);
              // try {
              //   const {
              //     location,
              //     address,
              //     location_lat,
              //     location_lng,
              //     password,
              //     ...storeData
              //   } = values;
              //   const latLng = `${location_lat},${location_lng}`;

              //   const payload = {
              //     ...storeData,
              //     location: {
              //       lat_long: latLng,
              //       address: location,
              //     },
              //   };

              //   const userData = await API_UPDATE_MAIN_LAUNDRY(
              //     payload,
              //     data?._id
              //   );
              //   Navigate("/admin/main-laundry-management/laundry-tables");

              //   toast.success(userData?.message);
              // } catch (error) {
              //   console.error("error", error);
              //   toast.error(error?.response?.data?.message);
              // } finally {
              //   setSubmitting(false);
              // }
            }}
          >
            {({ isSubmitting, values, setFieldValue }) => (
              <Form className="flex min-h-[36rem] w-full flex-col justify-between rounded-[20px] bg-white p-8 shadow-md ">
                <div
                  className="flex cursor-pointer items-center gap-2"
                  onClick={() => {
                    Navigate(-1);
                  }}
                >

                {console.log(data,'ladlfjksdhalfjk')}
                  <MdOutlineArrowBack
                    className="cursor-pointer"
                    style={{ fontSize: "17px" }}
                  />
                  <p>Back</p>
                </div>
                <Row gutter={[16, 16]}>
                  <Col span={12}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {" "}
                        {t("Laundry Name")}
                        <span className="text-[red]">*</span>
                      </label>
                      <Field
                        className="bg-transparent peer block w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        type="text"
                        name="laundry_name"
                        placeholder={t("Laundry Name")}
                        onKeyPress={(event) => {
                          const charCode = event.charCode;
                          if (
                            !(charCode >= 65 && charCode <= 90) && // A-Z
                            !(charCode >= 97 && charCode <= 122) && // a-z
                            charCode !== 32 // space
                          ) {
                            event.preventDefault();
                          }
                        }}
                      />
                      <ErrorMessage
                        name="laundry_name"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>

                  <Col span={12}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {" "}
                        {t("Phone No")} <span className="text-[red]">*</span>
                      </label>
                      <PhoneInput
                        disableDropdown={true}

                        country={"sa"}
                        // className="w-100 mt-2"
                        inputProps={{
                          className:
                            "bg-transparent peer block w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500 pl-[3rem]",

                          name: "phone_no",
                          placeholder: "Phone No",
                        }}
                        value={values?.phone_no}
                        onChange={(value) => {
                          setFieldValue("phone_no", value);
                        }}
                      />

                      <ErrorMessage
                        name="phone_no"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>
                  <Col span={12}>
                    <div className="relative mb-3">
                      <label className="font-semibold">
                        {t("Password")}
                        <span className="text-[red]">*</span>
                      </label>
                      
                      <Field
                        className="bg-transparent peer block w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        type={showPassword ? "text" : "password"}
                        name="password"
                        placeholder="Password"
                      />
                      <button
                        type="button"
                        onClick={() =>
                          setShowPassword((prevState) => !prevState)
                        }
                        className="absolute bottom-[-20px] right-4 top-3"
                      >
                        {showPassword ? <FaEyeSlash /> : <FaEye />}{" "}
                      </button>
                      <ErrorMessage
                        name="password"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>

                  <Col span={12}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {" "}
                        {t("Email")}
                        <span className="text-[red]">*</span>
                      </label>
                                            <Field
                        className="bg-transparent peer block w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        type="text"
                        name="email"
                        placeholder={t("Email")}

                        // autoComplete="off"
                      />
                      <ErrorMessage
                        name="email"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>

                  
                  <Col xs={24} md={12} lg={12} className="">
                   
                    <TextareaField
                      className="bg-transparent peer block w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                      label={t("Location")}
                      name="location"
                      // placeholder={t("Location")}
                      value={values?.location}
                      handleChange={(e) => {
                        const addressInput = e.target.value;
                        setFieldValue("location", addressInput);
                        searchAddress(addressInput); // Call the address autocomplete function
                      }}
                      // required
                    />
                    <ErrorMessage
                      name="location"
                      component="div"
                      className="text-red-500"
                    />
                    {autocompleteSuggestions.length > 0 && (
                      <AddressAutocomplete
                        suggestions={autocompleteSuggestions}
                        // onSelectAddress={onSelectAddress}
                        onSelectAddress={(address) =>
                          onSelectAddress(address, setFieldValue)
                        }
                      />
                    )}
                  </Col>
                  <Col span={12}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {" "}
                        {t("Description")} <span className="text-[red]">*</span>
                      </label>
                      <Field
                        className="bg-transparent peer block w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        as="textarea"
                        name="description"
                        placeholder={t("Description")}
                        // autoComplete="off"
                      />
                      <ErrorMessage
                        name="description"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>
                </Row>
                <div className="flex justify-end">
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="linear mt-2 w-full max-w-[12rem] rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
                  >
                    {/* {isSubmitting ? "Updating..." : " Update Main Laundry"} */}
                    {isSubmitting
                      ? t("Updating") + "..."
                      : t("Update Main Laundry")}
                  </button>
                </div>
              </Form>
            )}
          </Formik>
          {/* Confirmation Modal */}
          <Modal
            // title="Save Changes"
            visible={confirmModalVisible}
            onCancel={() => setConfirmModalVisible(false)}
            centered
            onOk={async () => {
              setConfirmModalVisible(false);
              try {
                const {
                  location,
                  address,
                  location_lat,
                  location_lng,
                  password,
                  ...storeData
                } = valuesData;
                const latLng = `${location_lat},${location_lng}`;

                const payload = {
                  ...storeData,
                  location: {
                    lat_long: latLng,
                    address: location,
                  },
                };

                const userData = await API_UPDATE_MAIN_LAUNDRY(
                  payload,
                  data?._id
                );
                Navigate("/admin/main-laundry-management/laundry-tables");

                toast.success(userData?.message);
              } catch (error) {
                console.error("error", error);
                toast.error(error?.response?.data?.message);
              } finally {
                // setSubmitting(false);
              }
            }}
          >
            <div
              className="flex items-center"
              style={{ flexDirection: "column" }}
            >
              <div>
                <p className="mb-1 font-bold">Save Changes</p>
                <p className="mb-8 font-medium">
                  Do you want to Save Changes before leaving the Page?
                </p>
              </div>
              <div className="flex gap-4">
                <button
                  className="linear text-black mt-2 w-full  rounded-xl py-[12px] text-base font-medium transition duration-200  dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
                  onClick={() => setConfirmModalVisible(false)}
                  style={{ width: "6rem" }}
                >
                  Cancel
                </button>
                <button
                  className="linear mt-2 w-full max-w-[10rem] rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
                  onClick={async () => {
                    setConfirmModalVisible(false);
                    try {
                      const {
                        location,
                        address,
                        location_lat,
                        location_lng,
                        password,
                        ...storeData
                      } = valuesData;
                      const latLng = `${location_lat},${location_lng}`;

                      const payload = {
                        ...storeData,
                        location: {
                          lat_long: latLng,
                          address: location,
                        },
                      };

                      const userData = await API_UPDATE_MAIN_LAUNDRY(
                        payload,
                        data?._id
                      );
                      Navigate("/admin/main-laundry-management/laundry-tables");

                      toast.success(userData?.message);
                    } catch (error) {
                      console.error("error", error);
                      toast.error(error?.response?.data?.message);
                    } finally {
                      // setSubmitting(false);
                    }
                  }}
                >
                  Save Changes
                </button>
              </div>
            </div>
          </Modal>
        </div>
      </div>
    </>
  );
};

export default EditLaundry;
